import React, { useState, useEffect } from 'react';
import "./Feed.css";
import StoryReel from './StoryReel.js';
import MessageSender from './MessageSender.js';
import Post from './Post.js';
import db from "./firebase";

function Feed() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        db.collection('posts').orderBy('timestamp', 'desc').onSnapshot((snapshot) => 
            setPosts(snapshot.docs.map((doc) => ({ id: doc.id, 
                data: doc.data() })))
        ); 
    }, []);

    return (
        <div className="feed">
            <StoryReel />
            <MessageSender />
            
            {
                posts.map((post) => (
                    <Post 
                        key ={post.id}
                        profilePic= {post.data.profilePic}
                        message = {post.data.message}
                        timestamp = {post.data.timestamp}
                        username = {post.data.username}
                        image = {post.data.image}
                    />

                ))
            }
            

        </div>
    )
}

export default Feed

/*

<Post 
                profilePic = "https://kprofiles.com/wp-content/uploads/2019/01/kim-minju-Izone-533x800.jpg"
                message="Woo This works"
                timestamp = "This is a timestamp"
                username = "Lovery"
                image = "https://i.pinimg.com/originals/4b/21/17/4b21175ea3a1c8aeace99ec721e795a5.jpg"
            />
{
                posts.map((post) => (
                    <Post 
                        key ={post.id}
                        profilePic= {post.data.profilePic}
                        message = {post.data.message}
                        timestamp = {post.data.timestamp}
                        username = {post.data.username}
                        image = {post.data.image}
                    />

                ))
            }

*/